import { styled } from '@stitches/react';
import { useMemo } from 'react';
import { useElements, useScene } from '../../hooks';
import { VariableName } from '../../types/enums';

export const VariableTextElement = ({ elementID }: { elementID: string }) => {
  const scene = useScene();
  const [element] = useElements({ id: elementID });

  const VariableText = useMemo(
    () => styled('span', element?.props?.class as {}),
    [element?.props?.class]
  );

  const choosePlaceholder = () => {
    switch (element?.props?.variable as VariableName) {
      case VariableName.AppName:
        return 'Your Game Name';
      case VariableName.AppDescription:
        return 'Sample description of your game. In this thrilling adventure game, players embark on an epic quest to save the realm from an ancient evil that threatens to engulf the world in darkness. Armed with magical abilities and a diverse set of companions, they must explore mysterious dungeons, solve challenging puzzles, and engage in intense battles to restore balance to the land. With stunning visuals, immersive storytelling, and strategic gameplay, this game promises an unforgettable journey through a rich and fantastical universe.';
      case VariableName.AppVersionLabel:
        return 'v1.0.0';
      case VariableName.AppTaskOperationName:
        if (scene.launcherStates.doesAppOngoingInstallTaskExist)
          return 'Installing';
        if (scene.launcherStates.doesAppOngoingUninstallTaskExist)
          return 'Uninstalling';
        if (scene.launcherStates.doesAppOngoingUpdateTaskExist)
          return 'Updating';
        if (scene.launcherStates.doesAppOngoingRepairTaskExist)
          return 'Repairing';
        return '';
      case VariableName.AppTaskPackageSize:
        return '274 MB';
      case VariableName.AppTaskDownloadedSize:
        return '132 MB';
      case VariableName.AppTaskDownloadSpeed:
        return '84Mb/s';
      case VariableName.AppTaskPercentage:
        return '45%';
      case VariableName.AppInstallPath:
        return 'C:/Program Files/Your Game Folder';
      case VariableName.AppInstallPackageSize:
        return '310 MB';
      case VariableName.AppUpdatePackageSize:
        return '28 MB';
    }

    return '';
  };

  return (
    <VariableText
      element-type="variableText"
      id={element?.id}
      {...scene.launcherStateProps}
      onDragStart={(e) => e.preventDefault()}
    >
      {choosePlaceholder()}
    </VariableText>
  );
};
